import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 100px 0px;
  height: flex;
  position: relative;
  z-index: 1;
`;

export const FormWrap = styled.div`
  height: 100 %;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and(max - width: 400px) {
    height: 80 %;
  }
`;

export const Icon = styled(Link)`
  margin-left: 32px;
  margin-top: 32px;
  text-decoration: none;
  color: #fff;
  font-weight: 700;
  font-size: 32px;

  @media screen and(max - width: 480px) {
    margin-left: 16px;
    margin-top: 8px;
  }
`;

export const FormContent = styled.div`
  height: 100 %;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and(max - width: 480px) {
    padding: 10px;
  }
`;

export const Form = styled.form`
  background: #010101;
  height: auto;
  width: 350px;
  z-index: 1;
  display: grid;
  margin: 0 auto;
  padding: 10px 32px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);

  @media screen and(max - width: 1000px) {
    padding: 32px 32px;
  }
`;

export const FormH1 = styled.h1`
  margin-bottom: 40px;
  color: #fff;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
`;

export const FormLabel = styled.label`
  margin-bottom: 12px;
  font-size: 14px;
  color: #fff;
`;

export const FormInput = styled.input`
  padding: 16px 16px;
  margin-bottom: 32px;
  border: none;
  border-radius: 4px;
`;

export const FormButton = styled.button`
  margin-top: 12px;
  background: #006ee6;
  padding: 12px 0;
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
`;

export const Text = styled.span`
  text-align: center;
  margin-top: 24px;
  color: #fff;
  font-size: 14px;
`;

export const NavBtnLink = styled(Link)`
  margin-top: 12px;
  border-radius: 4px;
  background: #006ee6;
  white-space: nowrap;
  padding: 16px 0px;
  color: #fff;
  font-size: 20px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #010606;
  }
`;